import hs303 from "./hs-303";
import ms205 from "./ms-205";
import ms206 from "./ms-206";
import ms207 from "./ms-207";
import ms208 from "./ms-208";
import ms209 from "./ms-209";
import ms210 from "./ms-210";
import ms212 from "./ms-212";
import ms242 from "./ms-242";
import hs205 from "./hs-205";
import loandetails from "./loandetails";
import cashcreditrenewal from "./cashcreditrenewal"; 
import securitydetails from "./securitydetails";
import loanaction from "./loanaction";
import loandocuments from "./loandocuments";
import otherinformation from "./otherinformation";
import npainformation from "./npainformation";
import intstopinformation from "./intstopinformation";
import vehicle from "./vehicle";
import gold from "./gold";
import guarantor from "./guarantor";
import installment from "./installment";

export default {
  hs303,
  ms205,
  ms206,
  ms207,
  ms208,
  ms209,
  ms210,
  ms212,
  ms242,
  hs205,
  loandetails,
  cashcreditrenewal,
  securitydetails,
  loanaction,
  loandocuments,
  otherinformation,
  npainformation,
  intstopinformation,
  vehicle,gold,guarantor,installment
};
